import UserLayout from "components/Layout/User";
import { Button } from "components/ui";

export default function User({ error, resetError, eventId }) {
  return (
    <UserLayout>
      <div role="alert">
        <p>Error</p>
        <pre>{error.message}</pre>
        <p className="mt-3">Please report with event ID: <b>{eventId}</b></p>
        <Button onClick={resetError} variant="secondary" data-testid="retry-button">Try again</Button>
      </div>
    </UserLayout>
  );
}
